"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var MarkerNotMoving = function MarkerNotMoving(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,19.74A7.74,7.74,0,1,1,19.74,12,7.75,7.75,0,0,1,12,19.74ZM12,7.26A4.74,4.74,0,1,0,16.74,12,4.75,4.75,0,0,0,12,7.26Z",
    fill: "#fff"
  }));
};

MarkerNotMoving.propTypes = {
  className: _propTypes["default"].string
};
MarkerNotMoving.defaultProps = {
  className: 'fill-primary'
};
var _default = MarkerNotMoving;
exports["default"] = _default;